import { select, put as putAction, takeEvery } from 'redux-saga/effects';
import { get, post } from 'redux/shelf/api';
import { createReducer } from 'redux/shelf/reducer';
import session from 'lib/session';
import { field } from 'redux/shelf';

export const actions = {
  fetch: get`settings/${session.getMerchant}/assets/styles/customize`(),
  update: post`settings/${session.getMerchant}/assets/styles/customize`(),
  fetchConfiguration: get`settings/${session.getMerchant}/assets/configuration`(
    field('config')
  ),
  fetchNewConfig: get`settings/${session.getMerchant}/assets/new-configuration`(
    field('config')
  ),
  fetchRecommendationTemplates:
    post`recommendations/${session.getMerchant}/templates`(),
  saveStyles: post`settings/${session.getMerchant}/assets/styles`(),
};

export const reducer = createReducer(actions);
